import { ApiService } from '../api/api.service';
import { Config } from '@/environment';
import { Store } from 'vuex';
import { AxiosInstance } from 'axios';
import { AppState } from '@/store';
import { Logger } from '../logger';
import { PaymentProviders } from '@/constants';
import { loadScript } from '@/helpers/util';
import { AnalyticsService } from '../analytics/analytics.service';

export interface PaymentService {
  loadChaseJsLibrary(): Promise<void>;
  loadPayeezyJsLibrary(): Promise<void>;
  getPaymentProvider(countryCode: string): string;
  isPaymentOnline(): boolean;
}

export class AppPaymentService extends ApiService implements PaymentService {
  private isChaseLibraryLoaded: boolean = false;
  private isPayeezyLibraryLoaded: boolean = false;

  constructor(private config: Config, protected store: Store<AppState>, protected httpClient: AxiosInstance, protected logger: Logger, protected analytics: AnalyticsService) {
    super(store, httpClient, logger, analytics);
  }

  getPaymentProvider(countryCode: string): string {
    switch (countryCode) {
      case 'US':
        return PaymentProviders.Payeezy;
      case 'CA':
        return PaymentProviders.Chase;
      default:
        return PaymentProviders.Payeezy;
    }
  }

  async loadChaseJsLibrary(): Promise<void> {
    if (!this.isChaseLibraryLoaded) {
      this.isChaseLibraryLoaded = true;
      return await loadScript(this.config.chase.jsLibraryUrl);
    }
  }

  async loadPayeezyJsLibrary(): Promise<void> {
    if (!this.isPayeezyLibraryLoaded) {
      this.isPayeezyLibraryLoaded = true;
      return await loadScript(this.config.payeezy.jsLibrary);
    }
  }

  isPaymentOnline(): boolean {
    const flags = this.store.state.featureFlags;
    const isPayeezy = this.store.state.checkout.paymentProvider == PaymentProviders.Payeezy;
    const isChase = this.store.state.checkout.paymentProvider == PaymentProviders.Chase;

    if (flags.orderingStatus && !flags.orderingStatus.aboveStorePaymentOnline) {
      return false;
    }

    if (flags.orderingStatus && isPayeezy && !flags.orderingStatus.isPayeezyPaymentOnline) {
      return false;
    }

    if (flags.orderingStatus && isChase && !flags.orderingStatus.isChasePaymentOnline) {
      return false;
    }

    return true;
  }  
}
